import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'semantic-ui-react'

import * as styles from './styles'

const ExpandIcon = ({ expanded, toggleExpand }) => (
  <div style={styles.icon}>
    <Icon name={expanded ? 'angle double up' : 'angle double down'} onClick={toggleExpand} size="large" />
  </div>
)

ExpandIcon.propTypes = {
  expanded: PropTypes.bool.isRequired,
  toggleExpand: PropTypes.func.isRequired,
}

export default ExpandIcon
